import { ImageMetadata } from '../services/api';

export type ImagePreviewSeed = Pick<ImageMetadata, 'id' | 'hash'> & Partial<Pick<ImageMetadata, 'time' | 'thumb' | 'published_at' | 'public_title'>>;
export interface ImagePreviewIndex {
    image: ImagePreviewSeed;
    items?: ImagePreviewSeed[];
    page?: number;
    crossPage?: boolean;
}

export const imagePreviewSeed = (image: ImagePreviewSeed): ImagePreviewSeed => ({
    id: image.id, hash: image.hash, time: image.time, thumb: image.thumb,
    published_at: image.published_at, public_title: image.public_title,
});
